import { render, staticRenderFns } from "./DashboardBestSelling.vue?vue&type=template&id=57b61d52&"
import script from "./DashboardBestSelling.vue?vue&type=script&lang=js&"
export * from "./DashboardBestSelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports